import fidimaLogo from "../asset/image/new-logo.svg";
import { resolveMediaUrl } from "../utils/mediaUrl";

export { fidimaLogo };

export function hasItemPhoto(photo) {
    return Boolean(photo && String(photo).trim());
}

export function resolveItemPhotoUrl(photo) {
    if (!hasItemPhoto(photo)) return null;
    return resolveMediaUrl(photo);
}

export function resolveBrandLogo(logo) {
    const resolved = resolveMediaUrl(logo);
    return resolved || fidimaLogo;
}
